import BaseService from 'services/base'

export default class WebshopCartService extends BaseService {
  constructor(api, url = 'webshop') {
    super(api, url)
    this.api = api
    this.url = url
  }

  addItemToCart(payload) {
    return this.post('cart/item', payload)
  }

  calculateCartQuantity() {
    return this.get('cart/quantity')
  }

  checkout(cartId) {
    return this.post(`cart/${cartId}/checkout`)
  }

  enableMultiAddress(payload) {
    return this.post('cart/item/multi-address', payload)
  }

  copyCart(payload) {
    return this.post('copycart', payload)
  }

  fetchTable(payload) {
    return this.post('carts', payload)
  }

  getLookups(payload) {
    return this.get('lookups', payload)
  }

  getClientSites({ clientId, ...payload }) {
    return this.get(`${clientId}/sites/search`, payload)
  }

  getClientEmployees({ clientId, ...payload }) {
    return this.get(`${clientId}/employees/search`, payload)
  }

  getPunchoutData() {
    return this.get('punchout')
  }

  removeCartItem({ cartId, itemId }) {
    return this.delete(`cart/${cartId}/item/${itemId}`)
  }

  updateCart(payload) {
    return this.post('cart/update', payload)
  }
}
